import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Scrollbar } from 'components';
import { FixedSizeList } from 'react-window';
import ArrowDown from './arrow-down.svg';
import CheckIcon from './check.svg';
import './dropdown.scss';

const DropdownRow = ({ index, style, data = {} }) => {
  return (
    <li
      style={style}
      test-id={`dropdown-item-${data.name}-${data.value}`}
      className={classnames('dd-list-item', {
        selected: data.value === data.list[index].value,
      })}
      key={index}
      onClick={() => data.selectItem(data.list[index])}
    >
      <span
        className={classnames('dd-list-item-title', {
          'dd-list-item-title-with-icon':
            data.showCheckIcon && data.value === data.list[index].value,
        })}
      >
        {data.list[index].title}
      </span>
      {data.showCheckIcon && data.value === data.list[index].value && (
        <CheckIcon className="dd-list-item-icon" />
      )}
    </li>
  );
};

class Dropdown extends PureComponent {
  constructor(props) {
    super(props);

    const { initMessage, showAllOption, noValueText } = props;

    this.state = {
      listOpen: false,
      headerTitle: showAllOption ? noValueText || 'All' : initMessage,
      searchValue: '',
      value: '',
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const result = {};
    const { showAllOption, initMessage, noValueText } = nextProps;
    const noValueTitle = showAllOption ? noValueText || 'All' : initMessage;

    if (nextProps.value !== prevState.value) {
      const newObjectItem = (nextProps.list || []).find(
        (listItem) =>
          listItem.title === nextProps.value ||
          listItem.value === nextProps.value ||
          +listItem.value === +nextProps.value,
      );
      result.value = nextProps.value;
      result.headerTitle =
        newObjectItem && newObjectItem.title
          ? newObjectItem.title
          : nextProps.value || noValueTitle;
    }

    return result;
  }

  componentDidUpdate(prevProps) {
    const { listOpen, se } = this.state;
    const { list, value } = this.props;

    if (list && value) {
      const selected = list.filter(
        (item) => item.value && item.value === value,
      );
      if (selected.length === 1) {
        this.setState({
          headerTitle: selected[0].title,
        });
      }
    }

    setTimeout(() => {
      if (listOpen) {
        window.addEventListener('click', this.close);
      } else {
        window.removeEventListener('click', this.close);
      }
    }, 0);
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.close);
  }

  close = () => {
    this.setState({
      listOpen: false,
    });
  };

  selectItem(item) {
    const savedValue = item.value !== undefined ? item.value : item.title;
    this.setState({
      headerTitle: item.title,
      listOpen: false,
      value: savedValue,
    });
    this.props.onChange(savedValue);
  }

  toggleList = () => {
    const { list, onFocusChange, disabled } = this.props;
    const { value } = this.state;

    if (disabled) {
      return;
    }

    if (list.length === 0 && onFocusChange) {
      onFocusChange(value);
    }

    this.setState((prevState) => ({
      listOpen: !prevState.listOpen,
    }));
  };

  onHandleInputTextField = (e) => {
    this.setState({ searchValue: e.target.value, value: e.target.value });
    this.props.onChange(e.target.value);
  };

  renserInputTextField = () => {
    const { listOpen, headerTitle, searchValue, value } = this.state;
    const { dropdownInputField, initMessage, onFocusChangeTextField } =
      this.props;

    if (listOpen) {
      return (
        <div className="input-component">
          <input
            type="text"
            autoFocus
            placeholder={headerTitle}
            onChange={this.onHandleInputTextField}
            value={searchValue}
            onFocus={onFocusChangeTextField}
          />
        </div>
      );
    }

    return (
      <div
        className={
          dropdownInputField && headerTitle === initMessage
            ? 'dd-header-title dd-header-title-small'
            : 'dd-header-title'
        }
      >
        {searchValue || value}
      </div>
    );
  };

  renderSearch = () => {
    const { listOpen, headerTitle } = this.state;
    const { dropdownInputField, initMessage } = this.props;

    if (listOpen) {
      return (
        <div className="input-component">
          <input
            type="text"
            autoFocus
            placeholder={headerTitle}
            onChange={(event) =>
              this.setState({ searchValue: event.target.value })
            }
            onFocus={() => this.setState({ searchValue: '' })}
          />
        </div>
      );
    }

    return (
      <div
        className={
          dropdownInputField && headerTitle === initMessage
            ? 'dd-header-title dd-header-title-small'
            : 'dd-header-title'
        }
      >
        {headerTitle}
      </div>
    );
  };

  render() {
    const {
      list,
      label,
      disabled,
      search,
      rowsCount,
      showCheckIcon,
      showAllOption,
      noValueText,
      value,
      name,
      initMessageClassName,
      fromRegistration,
      dropdownAndInputTextField,
    } = this.props;
    const { listOpen, headerTitle, searchValue } = this.state;

    let displayedList = searchValue
      ? list.filter(
          (listItem) =>
            listItem.title.toUpperCase().indexOf(searchValue.toUpperCase()) !==
            -1,
        )
      : list;

    if (showAllOption && !searchValue) {
      displayedList = [
        { value: null, title: noValueText ? 'Not selected' : 'All' },
        ...displayedList,
      ];
    }
    const height =
      displayedList.length >= rowsCount
        ? rowsCount * 32
        : displayedList.length * 32;

    return (
      <div className="dd-wrapper" test-id={`dropdown-${name}`}>
        <div
          className={classnames('dd-header', { _disabled: disabled })}
          onClick={this.toggleList}
        >
          {label && <div className="dd-header-label">{label}</div>}
          {search && this.renderSearch()}
          {dropdownAndInputTextField && this.renserInputTextField()}
          {!search && !dropdownAndInputTextField && (
            <div
              className={`dd-header-title ${
                initMessageClassName ? initMessageClassName : ''
              }`}
            >
              {headerTitle}
            </div>
          )}
          <ArrowDown
            style={{ minWidth: '12px' }}
            className={listOpen ? 'arrow-down' : ''}
          />
        </div>
        {listOpen && displayedList.length <= 1000 && (
          <div
            style={{ height: `${height}px` }}
            className="dd-list drop-list"
            onClick={(e) => e.stopPropagation()}
          >
            <Scrollbar>
              <ul style={{ width: '100%' }}>
                {displayedList.map((item, index) => (
                  <li
                    test-id={`dropdown-item-${name}-${item.value}`}
                    className={classnames(
                      !fromRegistration
                        ? 'dd-list-item'
                        : 'dd-list-item-without-height',
                      { selected: value === item.value },
                    )}
                    key={index}
                    onClick={() => this.selectItem(item)}
                  >
                    <span
                      className={classnames('dd-list-item-title', {
                        'dd-list-item-title-with-icon':
                          showCheckIcon && value === item.value,
                      })}
                    >
                      {item.title}
                    </span>
                    {showCheckIcon && value === item.value && (
                      <CheckIcon className="dd-list-item-icon" />
                    )}
                  </li>
                ))}
              </ul>
            </Scrollbar>
          </div>
        )}
        {listOpen && displayedList.length > 1000 && (
          <div
            style={{ height: `${height}px` }}
            className="dd-list"
            onClick={(e) => e.stopPropagation()}
          >
            <ul style={{ width: '100%' }}>
              <FixedSizeList
                height={height}
                itemCount={displayedList.length}
                itemSize={32}
                width={'calc(100%)'}
                itemData={{
                  list: displayedList,
                  name,
                  value,
                  showCheckIcon,
                  selectItem: this.selectItem.bind(this),
                }}
              >
                {DropdownRow}
              </FixedSizeList>
            </ul>
          </div>
        )}
      </div>
    );
  }
}

Dropdown.propTypes = {
  initMessage: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.any,
  list: PropTypes.array,
  disabled: PropTypes.bool,
  search: PropTypes.bool,
  rowsCount: PropTypes.number,
  showCheckIcon: PropTypes.bool,
  showAllOption: PropTypes.bool,
};

Dropdown.defaultProps = {
  initMessage: '',
  onChange: (e) => {},
  value: '',
  list: [],
  disabled: false,
  search: false,
  rowsCount: 6,
  showCheckIcon: false,
  showAllOption: false,
};

export default Dropdown;
